module.exports = __webpack_public_path__ + "img/bulb-outline.6aa40b72.svg";